import { render, staticRenderFns } from "./FileManage.vue?vue&type=template&id=4fa69606&scoped=true"
import script from "./FileManage.vue?vue&type=script&lang=js"
export * from "./FileManage.vue?vue&type=script&lang=js"
import style0 from "./FileManage.vue?vue&type=style&index=0&id=4fa69606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa69606",
  null
  
)

export default component.exports